<template>
  <div
    data-app="true"
    class="v-application v-application--is-ltr theme--light"
    id="app"
    style="height: auto; background: transparent"
  >
    <ModuleBase
      :link="scheduleRequestLink"
      :bookingLink="scheduleMakeBookingLink"
      :referer="referer"
      :show_weekday="true"
      :source="source"
    ></ModuleBase>
  </div>
</template>

<script>
/* eslint-disable */
import ModuleBase from "../components/ModuleBase";
import { VApp } from "vuetify/lib";

function addYandexMetrikaScripts(ya_counter_id) {
  (function (d, w, c) {
    (w[c] = w[c] || []).push(function () {
      try {
        w.yaCounter = new Ya.Metrika({
          id: ya_counter_id,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
        });
      } catch (e) {}
    });

    var n = d.getElementsByTagName("script")[0],
      s = d.createElement("script"),
      f = function () {
        n.parentNode.insertBefore(s, n);
      };
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://mc.yandex.ru/metrika/watch.js";

    if (w.opera == "[object Opera]") {
      d.addEventListener("DOMContentLoaded", f, false);
    } else {
      f();
    }
  })(document, window, "yandex_metrika_callbacks");
}

function addRoistatCounter(roistat_key) {
    var loadRoistat = function(){
    (function(w, d, s, h, id) {
        w.roistatProjectId = id; w.roistatHost = h;
        var p = d.location.protocol == "https:" ? "https://" : "http://";
        var u = /^.*roistat_visit=[^;]+(.*)?$/.test(d.cookie) ? "/dist/module.js" : "/api/site/1.0/"+id+"/init?referrer="+encodeURIComponent(d.location.href);
        var js = d.createElement(s); js.charset="UTF-8"; js.async = 1; js.src = p+h+u; var js2 = d.getElementsByTagName(s)[0]; js2.parentNode.insertBefore(js, js2);
      })(window, document, 'script', 'cloud.roistat.com', roistat_key);
  }

  loadRoistat();
  //var i = 0;
  //var _TIMEOUT = 100;
  //var trackRoistatVisit = function () {
  //  var regexp = /roistat_visit=([^&]+)/i;
  //  // eslint-disable-next-line no-extra-boolean-cast
  //  if (!!regexp.exec(document.location.search)) {
  //    loadRoistat();
  //    clearInterval(checkInterval);
  //  }
  //  if (i > 5) {
  //    loadRoistat();
  //    clearInterval(checkInterval);
  //  }
  //  i++;
  //};
  //var checkInterval = setInterval(trackRoistatVisit, _TIMEOUT);
}

export default {
  components: { ModuleBase, VApp },
  name: "App",
  data: () => {
    return {
      scheduleRequestLink: window.schedule_request_link,
      scheduleMakeBookingLink: window.schedule_make_booking_link,
      referer: window.referer,
      source: window.source,
    };
  },
  created() {
    if (window.yandex_metrika_code) {
      addYandexMetrikaScripts(window.yandex_metrika_code);
    }
    if (window.roistat_key) {
      addRoistatCounter(window.roistat_key)
    }
  },
};
</script>
